import { render, staticRenderFns } from "./TeamInviteLogin.vue?vue&type=template&id=1ddcef52&scoped=true"
import script from "./TeamInviteLogin.vue?vue&type=script&lang=ts"
export * from "./TeamInviteLogin.vue?vue&type=script&lang=ts"
import style0 from "./TeamInviteLogin.vue?vue&type=style&index=0&id=1ddcef52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddcef52",
  null
  
)

export default component.exports